
interface HighlightProps {
  children: React.ReactNode;
  variant?: 'marker' | 'bold' | 'underline' | 'badge';
  color?: 'red' | 'orange' | 'amber';
  className?: string;
}

export default function Highlight({ 
  children, 
  variant = 'marker', 
  color = 'red',
  className = '' 
}: HighlightProps) {
  const baseStyles = 'inline-block';
  
  const variantStyles = {
    marker: {
      red: 'bg-red-100 text-red-700 px-1 rounded',
      orange: 'bg-orange-100 text-orange-700 px-1 rounded',
      amber: 'bg-amber-100 text-amber-700 px-1 rounded'
    },
    bold: {
      red: 'text-red-600 font-bold',
      orange: 'text-orange-600 font-bold',
      amber: 'text-amber-600 font-bold'
    },
    underline: {
      red: 'text-red-600 font-semibold border-b-2 border-red-400',
      orange: 'text-orange-600 font-semibold border-b-2 border-orange-400',
      amber: 'text-amber-600 font-semibold border-b-2 border-amber-400'
    },
    badge: {
      red: 'bg-red-600 text-white px-2 py-0.5 rounded-md font-semibold text-sm',
      orange: 'bg-orange-600 text-white px-2 py-0.5 rounded-md font-semibold text-sm',
      amber: 'bg-amber-600 text-white px-2 py-0.5 rounded-md font-semibold text-sm'
    }
  };

  const styles = `${baseStyles} ${variantStyles[variant][color]} ${className}`;

  return <span className={styles}>{children}</span>;
}
